import axios from 'axios';

export default {
  FETCH_ACCOUNTS ({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            // axios.post('login/authenticate', payload)
            axios.get('login/getAllRecoveredAccounts')
                .then((response) => {
                    const { data: { data : { payload } } } = response;
                    localStorage.setItem('accounts', JSON.stringify(payload));
                    commit('SET_ACCOUNTS', payload);
                    commit('TOGGLE_LOADING', false);
                    resolve(payload);

                })
                .catch((error) => {
                    console.log('action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    ADD_ACCOUNT({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            console.log("add account recovery : ", payload);
            axios.post('login/recoverAccountWithNewEmail', payload)
                .then((response) => {
                    console.log('ADD_ACCOUNT action fetch response : ', response);
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('ADD_ACCOUNT action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/accounts/actions.js